<template>
  <details class="undo-protocol-entry" :class="{ '-no-changes': !undo.changes }">
    <summary class="undo-protocol-entry__title">
      {{ $te(`objectNames.${typeName}`) ? $t(`objectNames.${typeName}`) : typeName }}: {{ $te(`actions.${undo.action}`) ? $t(`actions.${undo.action}`) : undo.action }}
    </summary>
    <section v-if="undo.changes" class="undo-protocol-entry__changes">
      <undo-protocol-change v-for="(change, index) of undo.changes" :key="index" :change="change" />
    </section>
  </details>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { UndoEntry } from "@editor/store/undo/undo.store";

import UndoProtocolChange from "@editor/components/UndoProtocolChange.vue";

const props = defineProps<{
  undo: UndoEntry;
}>();

const typeName = computed(() => {
  return storeName.value.substring(0, storeName.value.length - 1);
});

const storeName = computed(() => {
  return stripModel(props.undo.storeId);
});

const stripModel = (storeId: string) => {
  return storeId.replace(/model\//, "");
};
</script>

<style lang="scss">
.undo-protocol-entry {
  &.-no-changes {
    font-style: italic;
    padding-left: 1em;

    ::marker {
      content: ' ';
    }
  }

  &__title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &__changes {
    overflow: auto;
    padding-left: 0.5em;
    background-color: var(--color-background);
  }
}
</style>